import React, { FC } from 'react';
import s from './popularCollectionsSlider.module.scss';
import { useGetCollections } from '@services/collection/hooks/useGetCollections';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { CollectionCard } from '@components/Cards/Collections/CollectionCard';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
type PopularCollectionsSliderProps = {};
const id = 'popular_collections_pagination';
export const PopularCollectionsSlider: FC<PopularCollectionsSliderProps> = () => {
  const {
    data,
    isLoading
  } = useGetCollections({
    limit: 3,
    sort: 'freshest'
  });
  if (isLoading) return <LogoLoader />;
  if (!data || !data.items.length) return null;
  return <div className={s.popularCollectionsSlider} data-sentry-component="PopularCollectionsSlider" data-sentry-source-file="PopularCollectionsSlider.tsx">
            <div className={s.popularCollectionsSlider__pagination} id={id} />
            <div className={s.popularCollectionsSlider__slider}>
                <Swiper slidesPerView={1} loop={true} spaceBetween={24} speed={1000} modules={[Pagination, Autoplay]}
      // autoplay={{
      //     delay: 5000,
      //     disableOnInteraction: false,
      // }}
      pagination={{
        clickable: true,
        el: `#${id}`,
        type: 'bullets'
      }} preventClicks data-sentry-element="Swiper" data-sentry-source-file="PopularCollectionsSlider.tsx">
                    {data.items?.map(({
          id,
          name,
          description,
          imageid
        }) => <SwiperSlide className={s.popularCollectionsSlider__slide} key={id}>
                            <CollectionCard id={id} name={name} description={description} imageId={imageid} />
                        </SwiperSlide>)}
                </Swiper>
            </div>
        </div>;
};